<template>
  <div :style="mapFilterBox">
    <div
      class="topNav__searchbar_wrapper"
      :style="isFilterOpen ? 'z-index: 999' : 'z-index:1'"
    >
      <div class="filterbutton_wrapper">
        <button ref="filterButton" class="filterbutton" @click.stop="toggleFilter">
          <VsxIcon iconName="Setting4" :size="25" color="#000" type="linear" />
        </button>
      </div>

      <input
        v-model="fillter.text"
        class="searchbar_input"
        type="search"
        inputmode="search"
        enterkeyhint="search"
        :placeholder="placeholderText"
        @keyup.enter="fillter_btn('list')"
      />
      <div
        @click.stop="toggleFilter"
        :style="SliderBar"
        class="BackgroundHover filterBG"
      >
        <div @click.stop :style="filterStyles" class="filter" ref="filterBox">
          <div class="filterTitle">
            <div class="filterTitleContainer">
              <h4>فیلتر</h4>
              <div class="headerBttonsWrapper">
                <div
                  class="clearButton"
                  :class="{
                    show: $route.path == '/' || $route.path == '/home',
                  }"
                  @click="restore_fillter()"
                >
                  <i class="fas fa-broom"></i>
                  <span>پاکسازی فرم</span>
                </div>
                <button @click="toggleFilter" class="closeFilterBtn">
                  <i class="fas fa-xmark"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="filter__container">
            <div class="filterTooltip" :class="{ show: showTooltip }">
              در بخش عنوان می‌توانید با وارد کردن نام، توضیحات، شناسه ملک، شماره
              مالک یا سایر اطلاعات مربوط به ملک، عملیات جستجو را انجام دهید.
            </div>
            <div class="filter__option filter__option--block">
              <div class="filter__option_title">
                <div class="filterPriceTitle">
                  <div class="titleWrapper">
                    عنوان
                    <div class="showInfo" @click="tooltipHandler">
                      <VsxIcon
                        iconName="InfoCircle"
                        :size="22"
                        color="#0096c7"
                        type="linear"
                      />
                    </div>
                  </div>
                  <div
                    class="filterPriceInputContainer filterPriceInputContainer--gridFull"
                  >
                    <input
                      type="text"
                      v-model="fillter.text"
                      class="filterSearchInput"
                      :placeholder="placeholderText"
                      @keyup.enter="fillter_btn('list')"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="filter__option filter__option--block">
              <div class="filter__option_title">
                <div class="filterPriceTitle">
                  دسته بندی
                  <div
                    class="filterPriceInputContainer filterPriceInputContainer--gridFull"
                  >
                    <el-select
                      class="fullFilterInput"
                      v-model="fillter.main_category"
                      placeholder="انتخاب"
                      style="width: 240px"
                    >
                      <el-option value="all" label="همه" />
                      <el-option
                        v-for="(v, i) in $store.state.c_set.main_category"
                        :key="i"
                        :value="i"
                        :label="v"
                      />
                    </el-select>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="filter__option filter__option--block"
              v-if="fillter.main_category == 'request'"
            >
              <div class="filter__option_title">
                <div class="filterPriceTitle">
                  نوع درخواست
                  <div
                    class="filterPriceInputContainer filterPriceInputContainer--gridFull"
                  >
                    <el-select
                      class="fullFilterInput"
                      v-model="fillter.request_type"
                      placeholder="انتخاب"
                      style="width: 240px"
                    >
                      <el-option value="all" label="همه" />
                      <el-option
                        v-for="(v, i) in $store.state.c_set.request_type"
                        :key="i"
                        :value="i"
                        :label="v"
                      />
                    </el-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="filter__option filter__option--block">
              <div class="filter__option_title">
                <div class="filterPriceTitle">
                  نوع ملک
                  <div
                    class="filterPriceInputContainer filterPriceInputContainer--gridFull"
                  >
                    <el-select
                      class="fullFilterInput"
                      v-model="fillter.category"
                      placeholder="انتخاب"
                      style="width: 240px"
                    >
                      <el-option value="all" label="همه" />
                      <el-option
                        v-for="(v, i) in $store.state.c_set.category"
                        :key="i"
                        :value="i"
                        :label="v"
                      />
                    </el-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="filter__option filter__option--block">
              <div class="filter__option_title">
                <div class="filterPriceTitle">
                  متراژ <span v-if="fillter.category != 'apartment'">بنا</span>
                  <div
                    class="filterPriceInputContainer filterPriceInputContainer--gridHalf"
                    style="margin-top: 2px"
                  >
                    <span class="filterMaxPrice">
                      <span> از</span>
                      <input
                        style="text-align: left; direction: ltr"
                        type="tel"
                        inputmode="numeric"
                        @input="(event) => setformatPrice(event, 'min_width')"
                        class="filterPriceInput"
                        v-model="front_show.min_width"
                      />
                    </span>
                    <span style="margin-top: 15px">
                      <span class="filterMinPrice">
                        <span>تا</span>
                        <input
                          style="text-align: left; direction: ltr"
                          type="text"
                          inputmode="numeric"
                          @input="(event) => setformatPrice(event, 'max_width')"
                          class="filterPriceInput"
                          v-model="front_show.max_width"
                        />
                      </span>
                      <span class="error-text">{{ errors.width }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="filter__option filter__option--block"
              v-if="
                fillter.category == 'villa_house' || fillter.category == 'villa'
              "
            >
              <div class="filter__option_title">
                <div class="filterPriceTitle">
                  متراژ زمین
                  <div
                    class="filterPriceInputContainer filterPriceInputContainer--gridHalf"
                    style="margin-top: 2px"
                  >
                    <span class="filterMaxPrice">
                      <span> از</span>
                      <input
                        style="text-align: left; direction: ltr"
                        type="tel"
                        inputmode="numeric"
                        @input="(event) => setformatPrice(event, 'min_width')"
                        class="filterPriceInput"
                        v-model="front_show.min_width"
                      />
                    </span>
                    <span style="margin-top: 15px">
                      <span class="filterMinPrice">
                        <span>تا</span>
                        <input
                          style="text-align: left; direction: ltr"
                          type="text"
                          inputmode="numeric"
                          @input="(event) => setformatPrice(event, 'max_width')"
                          class="filterPriceInput"
                          v-model="front_show.max_width"
                        />
                      </span>
                      <span class="error-text">{{ errors.width }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="filter__option filter__option--block"
              v-if="
                fillter.category == 'villa_house' &&
                fillter.main_category != 'rent'
              "
            >
              <div class="filter__option_title">
                <div class="filterPriceTitle">
                  عرض کوچه
                  <div
                    class="filterPriceInputContainer filterPriceInputContainer--gridHalf"
                    style="margin-top: 2px"
                  >
                    <span class="filterMaxPrice">
                      <span> از</span>
                      <input
                        style="text-align: left; direction: ltr"
                        type="tel"
                        inputmode="numeric"
                        @input="(event) => setformatPrice(event, 'min_width')"
                        class="filterPriceInput"
                        v-model="front_show.min_width"
                      />
                    </span>
                    <span style="margin-top: 15px">
                      <span class="filterMinPrice">
                        <span>تا</span>
                        <input
                          style="text-align: left; direction: ltr"
                          type="text"
                          inputmode="numeric"
                          @input="(event) => setformatPrice(event, 'max_width')"
                          class="filterPriceInput"
                          v-model="front_show.max_width"
                        />
                      </span>
                      <span class="error-text">{{ errors.width }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="filter__option filter__option--block"
              v-if="
                fillter.category == 'villa_house' &&
                fillter.main_category != 'rent'
              "
            >
              <div class="filter__option_title">
                <div class="filterPriceTitle">
                  عرض زمین
                  <div
                    class="filterPriceInputContainer filterPriceInputContainer--gridHalf"
                    style="margin-top: 2px"
                  >
                    <span class="filterMaxPrice">
                      <span> از</span>
                      <input
                        style="text-align: left; direction: ltr"
                        type="tel"
                        inputmode="numeric"
                        @input="(event) => setformatPrice(event, 'min_width')"
                        class="filterPriceInput"
                        v-model="front_show.min_width"
                      />
                    </span>
                    <span style="margin-top: 15px">
                      <span class="filterMinPrice">
                        <span>تا</span>
                        <input
                          style="text-align: left; direction: ltr"
                          type="text"
                          inputmode="numeric"
                          @input="(event) => setformatPrice(event, 'max_width')"
                          class="filterPriceInput"
                          v-model="front_show.max_width"
                        />
                      </span>
                      <span class="error-text">{{ errors.width }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="fillter.main_category !== 'rent'"
              class="filter__option filter__option--block"
            >
              <div class="filter__option_title">
                <div class="filterPriceTitle">
                  قیمت (تومان)
                  <div
                    class="filterPriceInputContainer filterPriceInputContainer--gridHalf"
                    style="margin-top: 2px"
                  >
                    <span class="filterMaxPrice">
                      <span> از</span>
                      <input
                        style="text-align: left; direction: ltr"
                        type="text"
                        inputmode="numeric"
                        class="filterPriceInput"
                        @input="(event) => setformatPrice(event, 'min_price')"
                        v-model="front_show.min_price"
                      />
                    </span>
                    <span style="margin-top: 15px">
                      <span class="filterMinPrice">
                        <span>تا</span>
                        <input
                          style="text-align: left; direction: ltr"
                          type="text"
                          inputmode="numeric"
                          class="filterPriceInput"
                          @input="(event) => setformatPrice(event, 'max_price')"
                          v-model="front_show.max_price"
                        />
                      </span>
                      <span class="error-text">{{ errors.price }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="fillter.main_category != 'trade'"
              class="filter__option filter__option--block"
            >
              <div class="filter__option_title">
                <div class="filterPriceTitle">
                  مبلغ رهن (تومان)
                  <div
                    class="filterPriceInputContainer filterPriceInputContainer--gridHalf"
                    style="margin-top: 2px"
                  >
                    <span class="filterMaxPrice">
                      <span> از</span>
                      <input
                        style="text-align: left; direction: ltr"
                        class="filterPriceInput"
                        type="text"
                        inputmode="numeric"
                        @input="
                          (event) => setformatPrice(event, 'min_mortageprice')
                        "
                        v-model="front_show.min_mortageprice"
                      />
                    </span>
                    <span style="margin-top: 15px">
                      <span class="filterMinPrice">
                        <span>تا</span>
                        <input
                          style="text-align: left; direction: ltr"
                          class="filterPriceInput"
                          type="text"
                          inputmode="numeric"
                          @input="
                            (event) => setformatPrice(event, 'max_mortageprice')
                          "
                          v-model="front_show.max_mortageprice"
                        />
                      </span>
                      <span class="error-text">{{ errors.mortage }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="fillter.main_category != 'trade'"
              class="filter__option filter__option--block"
            >
              <div class="filter__option_title">
                <div class="filterPriceTitle">
                  مبلغ اجاره (تومان)
                  <div
                    class="filterPriceInputContainer filterPriceInputContainer--gridHalf"
                    style="margin-top: 2px"
                  >
                    <span class="filterMaxPrice">
                      <span> از</span>
                      <input
                        style="text-align: left; direction: ltr"
                        class="filterPriceInput"
                        type="text"
                        inputmode="numeric"
                        @input="
                          (event) => setformatPrice(event, 'min_rent_price')
                        "
                        v-model="front_show.min_rent_price"
                      />
                    </span>

                    <span style="margin-top: 15px">
                      <span class="filterMinPrice">
                        <span>تا</span>
                        <input
                          type="text"
                          style="text-align: left; direction: ltr"
                          class="filterPriceInput"
                          inputmode="numeric"
                          @input="
                            (event) => setformatPrice(event, 'max_rent_price')
                          "
                          v-model="front_show.max_rent_price"
                        />
                      </span>
                      <span class="error-text">{{ errors.rent }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="filter__option filter__option--block">
              <div class="filter__option_title">
                <div class="filterPriceTitle">
                  تعداد اتاق
                  <div
                    class="filterPriceInputContainer filterPriceInputContainer--flexWrap"
                  >
                    <div
                      class="roomNumBox"
                      :class="{ selected: fillter.bed === 0 }"
                      @click="fillter.bed = 0"
                    >
                      بدون اتاق
                    </div>

                    <div
                      class="roomNumBox"
                      :class="{ selected: fillter.bed === 1 }"
                      @click="fillter.bed = 1"
                    >
                      1
                    </div>
                    <div
                      class="roomNumBox"
                      :class="{ selected: fillter.bed === 2 }"
                      @click="fillter.bed = 2"
                    >
                      2
                    </div>
                    <div
                      class="roomNumBox"
                      :class="{ selected: fillter.bed === 3 }"
                      @click="fillter.bed = 3"
                    >
                      3
                    </div>
                    <div
                      class="roomNumBox"
                      :class="{ selected: fillter.bed === 4 }"
                      @click="fillter.bed = 4"
                    >
                      4
                    </div>
                    <div
                      class="roomNumBox"
                      :class="{ selected: fillter.bed === 5 }"
                      @click="fillter.bed = 5"
                    >
                      4+
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="filter__option filter__option--block">
              <div class="filter__option_title">
                <div class="filterPriceTitle">
                  سن بنا
                  <div
                    class="filterPriceInputContainer filterPriceInputContainer--gridHalf"
                  >
                    <span class="filterMaxPrice">
                      <span> از</span>
                      <el-select
                        class="minfullFilterInput"
                        v-model="fillter.min_age"
                        placeholder=""
                        style="width: 240px"
                      >
                        <el-option
                          v-for="(v, i) in propertyAgeOptions"
                          :key="i"
                          :value="i"
                          :label="v.ageLabel"
                        />
                      </el-select>
                    </span>
                    <span class="filterMinPrice">
                      <span>تا</span>
                      <el-select
                        class="minfullFilterInput"
                        v-model="fillter.max_age"
                        placeholder=""
                        style="width: 240px"
                      >
                        <el-option
                          v-for="(v, i) in propertyAgeOptions"
                          :key="i"
                          :value="i"
                          :label="v.ageLabel"
                        />
                      </el-select>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="filter__option filter__option--block"
              v-if="
                fillter.category != 'villa_house' &&
                fillter.category != 'villa' &&
                fillter.category != 'commercial' &&
                fillter.category != 'garden' &&
                fillter.category != 'land' &&
                fillter.category != 'industrial'
              "
            >
              <div class="filter__option_title">
                <div class="filterPriceTitle">
                  طبقه
                  <div
                    class="filterPriceInputContainer filterPriceInputContainer--gridHalf"
                  >
                    <span class="filterMaxPrice">
                      <span> از</span>
                      <el-select
                        class="minfullFilterInput"
                        v-model="fillter.min_floor"
                        placeholder=""
                        style="width: 240px"
                      >
                        <el-option value="0" label="انتخاب کنید" />
                        <el-option
                          v-for="(v, i) in 10"
                          :key="i"
                          :value="i"
                          :label="'طبقه ' + v"
                        />
                      </el-select>
                    </span>
                    <span class="filterMinPrice">
                      <span>تا</span>
                      <el-select
                        class="minfullFilterInput"
                        v-model="fillter.max_floor"
                        placeholder=""
                        style="width: 240px"
                      >
                        <el-option value="0" label="انتخاب کنید" />
                        <el-option
                          v-for="(v, i) in 10"
                          :key="i"
                          :value="i"
                          :label="'طبقه ' + v"
                        />
                      </el-select>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="filter__option filter__option--block"
              v-if="
                fillter.category != 'villa_house' &&
                fillter.category != 'villa' &&
                fillter.category != 'commercial' &&
                fillter.category != 'garden' &&
                fillter.category != 'land' &&
                fillter.category != 'industrial'
              "
            >
              <div class="filter__option_title">
                <div class="filterPriceTitle">
                  تعداد طبقات
                  <div
                    class="filterPriceInputContainer filterPriceInputContainer--gridHalf"
                  >
                    <span class="filterMaxPrice">
                      <span> از</span>
                      <el-select
                        class="minfullFilterInput"
                        v-model="fillter.min_totalFloor"
                        placeholder=""
                        style="width: 240px"
                      >
                        <el-option value="0" label="انتخاب کنید" />
                        <el-option
                          v-for="(v, i) in 10"
                          :key="i"
                          :value="i"
                          :label="v + ' طبقه'"
                        />
                      </el-select>
                    </span>
                    <span class="filterMinPrice">
                      <span>تا</span>
                      <el-select
                        class="minfullFilterInput"
                        v-model="fillter.max_totalFloor"
                        placeholder=""
                        style="width: 240px"
                      >
                        <el-option value="0" label="انتخاب کنید" />
                        <el-option
                          v-for="(v, i) in 10"
                          :key="i"
                          :value="i"
                          :label="v + ' طبقه'"
                        />
                      </el-select>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="filter__option filter__option--block"
              v-if="
                fillter.category != 'villa_house' &&
                fillter.category != 'villa' &&
                fillter.category != 'commercial' &&
                fillter.category != 'garden' &&
                fillter.category != 'land' &&
                fillter.category != 'industrial'
              "
            >
              <div class="filter__option_title">
                <div class="filterPriceTitle">
                  تعداد واحد
                  <div
                    class="filterPriceInputContainer filterPriceInputContainer--gridHalf"
                  >
                    <span class="filterMaxPrice">
                      <span> از</span>
                      <el-select
                        class="minfullFilterInput"
                        v-model="fillter.max_Floorunit"
                        placeholder=""
                        style="width: 240px"
                      >
                        <el-option value="0" label="انتخاب کنید" />
                        <el-option
                          v-for="i in 15"
                          :key="i"
                          :value="i"
                          :label="`${i} واحد`"
                        >
                        </el-option>
                        <el-option :value="16" :label="'بیش از 15 واحد'">
                        </el-option>
                      </el-select>
                    </span>
                    <span class="filterMinPrice">
                      <span>تا</span>
                      <el-select
                        class="minfullFilterInput"
                        v-model="fillter.min_Floorunit"
                        placeholder=""
                        style="width: 240px"
                      >
                        <el-option value="0" label="انتخاب کنید" />
                        <el-option
                          v-for="i in 15"
                          :key="i"
                          :value="i"
                          :label="`${i} واحد`"
                        />
                        <el-option :value="16" :label="'بیش از 15 واحد'" />
                      </el-select>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="filter__option filter__option--block"
              v-if="fillter.main_category != 'rent'"
            >
              <div class="filter__option_title">
                <div class="filterPriceTitle">
                  سند
                  <div
                    class="filterPriceInputContainer filterPriceInputContainer--gridFull"
                  >
                    <el-select
                      class="fullFilterInput"
                      v-model="fillter.docType"
                      placeholder="انتخاب"
                      style="width: 240px"
                    >
                      <el-option value="0" label="انتخاب کنید" />
                      <el-option
                        v-for="(v, i) in $store.state.c_set.doc_type"
                        :key="i"
                        :value="i"
                        :label="v"
                      />
                    </el-select>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="filter__option filter__option--block"
              v-if="
                fillter.category == 'land' ||
                (fillter.category == 'Administrative' &&
                  fillter.main_category != 'rent')
              "
            >
              <div class="filter__option_title">
                <div class="filterPriceTitle">
                  نوع کاربری
                  <div
                    class="filterPriceInputContainer filterPriceInputContainer--gridFull"
                  >
                    <el-select
                      class="fullFilterInput"
                      v-model="fillter.sub_category"
                      placeholder="انتخاب"
                      style="width: 240px"
                    >
                      <el-option
                        v-for="(v, i) in front_show.sub_category"
                        :key="i"
                        :value="v.value"
                        :label="v.label"
                      />
                    </el-select>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="
                fillter.category == 'villa' &&
                fillter.main_category != 'rent' &&
                fillter.request_type != 'rent'
              "
              class="filter__option filter__option--block"
            >
              <div class="filter__option_title">
                <div class="filterPriceTitle">
                  پروانه ساخت
                  <div
                    class="filterPriceInputContainer filterPriceInputContainer--gridFull"
                  >
                    <el-select
                      class="fullFilterInput"
                      v-model="fillter.license"
                      placeholder="انتخاب کنید"
                      style="width: 240px"
                    >
                      <el-option value="دارد" label="دارد" />
                      <el-option value="ندارد" label="ندارد" />
                    </el-select>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="
                fillter.category == 'villa' &&
                fillter.main_category != 'rent' &&
                fillter.request_type != 'rent'
              "
              class="filter__option filter__option--block"
            >
              <div class="filter__option_title">
                <div class="filterPriceTitle">
                  پایان کار
                  <div
                    class="filterPriceInputContainer filterPriceInputContainer--gridFull"
                  >
                    <el-select
                      class="fullFilterInput"
                      v-model="fillter.workEnd"
                      placeholder="انتخاب کنید"
                      style="width: 240px"
                    >
                      <el-option value="دارد" label="دارد" />
                      <el-option value="ندارد" label="ندارد" />
                    </el-select>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="fillter.main_category != 'rent'"
              class="filter__option filter__option--block"
            >
              <div class="filter__option_title">
                <div class="filterPriceTitle">
                  آگهی دهنده
                  <div
                    class="filterPriceInputContainer filterPriceInputContainer--gridFull"
                  >
                    <el-select
                      class="fullFilterInput"
                      v-model="fillter.advertiser"
                      placeholder="انتخاب"
                      style="width: 240px"
                    >
                      <el-option
                        v-for="(v, i) in advertiserOptions"
                        :key="i"
                        :value="v.advertiserValue"
                        :label="v.adverTiserLable"
                      />
                    </el-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="filter__option filter__option--block">
              <div class="filter__option_title">
                <div class="filterPriceTitle">
                  منطقه مورد نظر
                  <div
                    class="filterPriceInputContainer filterPriceInputContainer--gridFull"
                  >
                    <el-select
                      class="fullFilterInput"
                      v-model="fillter.district"
                      filterable
                      placeholder="انتخاب"
                      style="width: 240px"
                    >
                      <el-option value="0" label="انتخاب کنید" />
                      <el-option
                        v-for="(v, i) in front_show.district_list"
                        :key="i"
                        :value="v.key"
                        :label="v.label"
                      />
                    </el-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="filterSwitchOption">
              <div class="switchOptionBox">
                <div class="switchTitle">دارای عکس</div>
                <div class="button r" id="button-3">
                  <input
                    type="checkbox"
                    v-model="fillter.photo"
                    class="checkbox"
                  />
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </div>

              <div class="switchOptionBox">
                <div class="switchTitle">آگهی فوری</div>
                <div class="button r" id="button-3">
                  <input
                    type="checkbox"
                    :class="{ checked: fillter.fast }"
                    v-model="fillter.fast"
                    class="checkbox"
                  />
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </div>
              <div
                class="switchOptionBox"
                v-if="fillter.category == 'apartment'"
              >
                <div class="switchTitle">پارکینگ</div>
                <div class="button r" id="button-3">
                  <input
                    type="checkbox"
                    v-model="fillter.parking"
                    class="checkbox"
                  />
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </div>
              <div
                class="switchOptionBox"
                v-if="fillter.category == 'apartment'"
              >
                <div class="switchTitle">انباری</div>
                <div class="button r" id="button-3">
                  <input
                    type="checkbox"
                    v-model="fillter.storage"
                    class="checkbox"
                  />
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </div>
              <div
                class="switchOptionBox"
                v-if="
                  fillter.category == 'apartment' &&
                  fillter.request_type != 'rent' &&
                  fillter.main_category != 'rent'
                "
              >
                <div class="switchTitle">بازسازی شده</div>
                <div class="button r" id="button-3">
                  <input
                    type="checkbox"
                    v-model="fillter.rebuild"
                    class="checkbox"
                  />
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </div>
              <div
                class="switchOptionBox"
                v-if="fillter.category == 'apartment'"
              >
                <div class="switchTitle">مطبخ</div>
                <div class="button r" id="button-3">
                  <input
                    type="checkbox"
                    v-model="fillter.matbakh"
                    class="checkbox"
                  />
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </div>
              <div
                class="switchOptionBox"
                v-if="fillter.category == 'apartment'"
              >
                <div class="switchTitle">تراس</div>
                <div class="button r" id="button-3">
                  <input
                    type="checkbox"
                    v-model="fillter.teras"
                    class="checkbox"
                  />
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </div>
              <div
                class="switchOptionBox"
                v-if="fillter.category == 'apartment'"
              >
                <div class="switchTitle">دانشجو/مجرد</div>
                <div class="button r" id="button-3">
                  <input
                    type="checkbox"
                    v-model="fillter.student"
                    class="checkbox"
                  />
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </div>
              <div
                class="switchOptionBox"
                v-if="fillter.category == 'apartment'"
              >
                <div class="switchTitle">قابل معاوضه</div>
                <div class="button r" id="button-3">
                  <input
                    type="checkbox"
                    v-model="fillter.exchangeable"
                    class="checkbox"
                  />
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </div>
              <div
                class="switchOptionBox"
                v-if="fillter.category == 'apartment'"
              >
                <div class="switchTitle">پنت هاوس</div>
                <div class="button r" id="button-3">
                  <input
                    type="checkbox"
                    v-model="fillter.pent"
                    class="checkbox"
                  />
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </div>
              <div
                class="switchOptionBox"
                v-if="
                  fillter.category == 'apartment' &&
                  (fillter.main_category == 'trade' ||
                    fillter.main_category == 'all')
                "
              >
                <div class="switchTitle">آسانسور</div>
                <div class="button r" id="button-3">
                  <input
                    type="checkbox"
                    v-model="fillter.elevator"
                    class="checkbox"
                  />
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </div>
              <div
                class="switchOptionBox"
                v-if="fillter.category == 'villa_house'"
              >
                <div class="switchTitle">دوبلکس</div>
                <div class="button r" id="button-3">
                  <input
                    type="checkbox"
                    v-model="fillter.doblex"
                    class="checkbox"
                  />
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </div>
              <div
                class="switchOptionBox"
                v-if="fillter.category == 'villa_house'"
              >
                <div class="switchTitle">تریپلکس</div>
                <div class="button r" id="button-3">
                  <input
                    type="checkbox"
                    v-model="fillter.soblex"
                    class="checkbox"
                  />
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </div>
              <div
                class="switchOptionBox"
                v-if="fillter.category == 'villa_house'"
              >
                <div class="switchTitle">روی پیلوت</div>
                <div class="button r" id="button-3">
                  <input
                    type="checkbox"
                    v-model="fillter.pilot"
                    class="checkbox"
                  />
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </div>
              <div
                class="switchOptionBox"
                v-if="fillter.category == 'villa_house'"
              >
                <div class="switchTitle">کف کرسی</div>
                <div class="button r" id="button-3">
                  <input
                    type="checkbox"
                    v-model="fillter.seatBottom"
                    class="checkbox"
                  />
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </div>
              <div
                class="switchOptionBox"
                v-if="fillter.category == 'commercial'"
              >
                <div class="switchTitle">شیشه سکوریت</div>
                <div class="button r" id="button-3">
                  <input
                    type="checkbox"
                    v-model="fillter.isglass"
                    class="checkbox"
                  />
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </div>
              <div
                class="switchOptionBox"
                v-if="fillter.category == 'commercial'"
              >
                <div class="switchTitle">کرکره برقی</div>
                <div class="button r" id="button-3">
                  <input
                    type="checkbox"
                    v-model="fillter.isremotedoor"
                    class="checkbox"
                  />
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </div>
              <div
                class="switchOptionBox"
                v-if="
                  fillter.category == 'commercial' ||
                  fillter.category == 'garden'
                "
              >
                <div class="switchTitle">آب</div>
                <div class="button r" id="button-3">
                  <input
                    type="checkbox"
                    v-model="fillter.iswater"
                    class="checkbox"
                  />
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </div>
              <div
                class="switchOptionBox"
                v-if="
                  fillter.category == 'commercial' ||
                  fillter.category == 'garden'
                "
              >
                <div class="switchTitle">برق</div>
                <div class="button r" id="button-3">
                  <input
                    type="checkbox"
                    v-model="fillter.iselectricity"
                    class="checkbox"
                  />
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </div>
              <div
                class="switchOptionBox"
                v-if="
                  fillter.category == 'commercial' ||
                  fillter.category == 'garden'
                "
              >
                <div class="switchTitle">گاز</div>
                <div class="button r" id="button-3">
                  <input
                    type="checkbox"
                    v-model="fillter.isgas"
                    class="checkbox"
                  />
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </div>
              <div class="switchOptionBox" v-if="fillter.category == 'garden'">
                <div class="switchTitle">خارج بافت</div>
                <div class="button r" id="button-3">
                  <input
                    type="checkbox"
                    v-model="fillter.outbaft"
                    class="checkbox"
                  />
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </div>
              <div class="switchOptionBox" v-if="fillter.category == 'garden'">
                <div class="switchTitle">داخل بافت</div>
                <div class="button r" id="button-3">
                  <input
                    type="checkbox"
                    v-model="fillter.inbaft"
                    class="checkbox"
                  />
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </div>
              <div
                class="switchOptionBox"
                v-if="
                  fillter.category == 'villa_house' &&
                  (fillter.main_category == 'trade' ||
                    fillter.main_category == 'all')
                "
              >
                <div class="switchTitle">قابل سکونت</div>
                <div class="button r" id="button-3">
                  <input
                    type="checkbox"
                    v-model="fillter.liveable"
                    class="checkbox"
                  />
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="filterButton__wrapper wrapperGrid">
            <button
              class="searchButton"
              v-if="$route.path == '/home' || $route.path == '/'"
              @click="fillter_btn('list')"
            >
              <i class="fas fa-list"></i>
              جستجو در لیست
            </button>
            <button
              class="searchButton"
              v-if="$route.path == '/home' || $route.path == '/'"
              @click="fillter_btn('map')"
            >
              <i class="fas fa-map-marker-alt"></i>
              جستجو در نقشه
            </button>

            <button
              class="searchButton"
              v-if="$route.path == '/category' || $route.path == '/map-house'"
              @click="fillter_btn()"
            >
              <VsxIcon
                iconName="Filter"
                :size="24"
                color="#f5f5f5"
                type="linear"
              />
              اعمال فیلتر
            </button>
            <button
              v-if="$route.path == '/category' || $route.path == '/map-house'"
              class="searchButton"
              @click="restore_fillter()"
            >
              <i class="fas fa-broom"></i>
              پاکسازی فرم
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="swiperFilterList">
      <Swiper :slides-per-view="'auto'" :space-between="9">
        <SwiperSlide
          v-if="fillter.category != 'land' && fillter.category != 'garden'"
        >
          <label
            class="filterThumb"
            for="complate_mortage1"
            :class="fillter.complate_mortage ? 'filter_avtive' : ''"
            @click="set_filter()"
          >
            <div class="filterTit">رهن کامل</div>
            <input
              type="checkbox"
              hidden
              id="complate_mortage1"
              v-model="fillter.complate_mortage"
            />
          </label>
        </SwiperSlide>
        <SwiperSlide
          v-if="
            fillter.category == 'apartment' ||
            fillter.category == 'Administrative' ||
            fillter.category == 'villa_house' ||
            fillter.category == 'commercial'
          "
        >
          <label
            class="filterThumb"
            for="rent_mortage1"
            :class="fillter.rent_mortage ? 'filter_avtive' : ''"
            @click="set_filter()"
          >
            <div class="filterTit">رهن و اجاره</div>
            <input
              type="checkbox"
              hidden
              id="rent_mortage1"
              v-model="fillter.rent_mortage"
            />
          </label>
        </SwiperSlide>

        <SwiperSlide v-if="fillter.category == 'villa'">
          <label
            class="filterThumb"
            for="dayli_rent1"
            :class="fillter.dayli_rent ? 'filter_avtive' : ''"
            @click="set_filter()"
          >
            <div class="filterTit">اجاره روزانه</div>
            <input
              type="checkbox"
              hidden
              id="dayli_rent1"
              v-model="fillter.dayli_rent"
            />
          </label>
        </SwiperSlide>
        <SwiperSlide
          v-if="fillter.category != 'land' && fillter.category != 'garden'"
        >
          <label
            class="filterThumb"
            for="convertable1"
            :class="fillter.convertable ? 'filter_avtive' : ''"
            @click="set_filter()"
          >
            <div class="filterTit">قابل تبدیل</div>
            <input
              type="checkbox"
              hidden
              id="convertable1"
              v-model="fillter.convertable"
            />
          </label>
        </SwiperSlide>
        <SwiperSlide
          v-if="
            fillter.category != 'Administrative' &&
            fillter.category != 'villa_house' &&
            fillter.category != 'commercial' &&
            fillter.category != 'industrial' &&
            fillter.category != 'garden' &&
            fillter.category != 'land' &&
            fillter.category != 'villa'
          "
        >
          <label
            class="filterThumb"
            for="single_unit1"
            :class="fillter.single_unit ? 'filter_avtive' : ''"
            @click="set_filter()"
          >
            <div class="filterTit">تک واحدی</div>
            <input
              type="checkbox"
              hidden
              id="single_unit1"
              v-model="fillter.single_unit"
            />
          </label>
        </SwiperSlide>
        <SwiperSlide
          v-if="
            fillter.category != 'commercial' &&
            fillter.category != 'garden' &&
            fillter.category != 'land' &&
            fillter.category != 'industrial'
          "
        >
          <label
            class="filterThumb"
            for="two_room1"
            :class="fillter.two_room ? 'filter_avtive' : ''"
            @click="set_filter()"
          >
            <div class="filterTit">دو اتاق</div>
            <input
              type="checkbox"
              hidden
              id="two_room1"
              v-model="fillter.two_room"
            />
          </label>
        </SwiperSlide>
        <SwiperSlide
          v-if="
            fillter.category != 'commercial' &&
            fillter.category != 'garden' &&
            fillter.category != 'land' &&
            fillter.category != 'industrial'
          "
        >
          <label
            class="filterThumb"
            for="three_room1"
            :class="fillter.three_room ? 'filter_avtive' : ''"
            @click="set_filter()"
          >
            <div class="filterTit">سه اتاق</div>
            <input
              type="checkbox"
              hidden
              id="three_room1"
              v-model="fillter.three_room"
            />
          </label>
        </SwiperSlide>
        <SwiperSlide
          v-if="
            fillter.category != 'Administrative' &&
            fillter.category != 'villa_house' &&
            fillter.category != 'commercial' &&
            fillter.category != 'industrial' &&
            fillter.category != 'land' &&
            fillter.category != 'garden' &&
            fillter.category != 'villa'
          "
        >
          <label
            class="filterThumb"
            for="pent1"
            :class="fillter.pent ? 'filter_avtive' : ''"
            @click="set_filter()"
          >
            <div class="filterTit">پنت هاوس</div>
            <input type="checkbox" hidden id="pent1" v-model="fillter.pent" />
          </label>
        </SwiperSlide>
        <SwiperSlide
          v-if="
            fillter.category != 'Administrative' &&
            fillter.category != 'garden' &&
            fillter.category != 'land' &&
            fillter.category != 'industrial'
          "
        >
          <label
            class="filterThumb"
            for="doblex1"
            :class="fillter.doblex ? 'filter_avtive' : ''"
            @click="set_filter()"
          >
            <div class="filterTit">دوبلکس</div>
            <input
              type="checkbox"
              hidden
              id="doblex1"
              v-model="fillter.doblex"
            />
          </label>
        </SwiperSlide>

        <SwiperSlide v-if="fillter.category == 'Administrative'">
          <label
            class="filterThumb"
            for="iswc1"
            :class="fillter.iswc ? 'filter_avtive' : ''"
            @click="set_filter()"
          >
            <div class="filterTit">سرویس بهداشتی</div>
            <input type="checkbox" hidden id="iswc1" v-model="fillter.iswc" />
          </label>
        </SwiperSlide>

        <SwiperSlide v-if="fillter.category == 'villa'">
          <label
            class="filterThumb"
            for="ispool1"
            :class="fillter.ispool ? 'filter_avtive' : ''"
            @click="set_filter()"
          >
            <div class="filterTit">اسختر</div>
            <input
              type="checkbox"
              hidden
              id="ispool1"
              v-model="fillter.ispool"
            />
          </label>
        </SwiperSlide>
        <SwiperSlide v-if="fillter.category == 'villa'">
          <label
            class="filterThumb"
            for="isjacozi1"
            :class="fillter.isjacozi ? 'filter_avtive' : ''"
            @click="set_filter()"
          >
            <div class="filterTit">جکوزی</div>
            <input
              type="checkbox"
              hidden
              id="isjacozi1"
              v-model="fillter.isjacozi"
            />
          </label>
        </SwiperSlide>
        <SwiperSlide
          v-if="
            fillter.category != 'villa_house' &&
            fillter.category != 'commercial' &&
            fillter.category != 'garden' &&
            fillter.category != 'land' &&
            fillter.category != 'industrial'
          "
        >
          <label
            class="filterThumb"
            for="elevator1"
            :class="fillter.elevator ? 'filter_avtive' : ''"
            @click="set_filter()"
          >
            <div class="filterTit">آسانسور</div>
            <input
              type="checkbox"
              hidden
              id="elevator1"
              v-model="fillter.elevator"
            />
          </label>
        </SwiperSlide>
        <SwiperSlide
          v-if="
            fillter.category != 'commercial' &&
            fillter.category != 'garden' &&
            fillter.category != 'industrial'
          "
        >
          <label
            class="filterThumb"
            for="doc_ismelk1"
            :class="fillter.doc_ismelk ? 'filter_avtive' : ''"
            @click="set_filter()"
          >
            <div class="filterTit">سند ملک</div>
            <input
              type="checkbox"
              hidden
              id="doc_ismelk1"
              v-model="fillter.doc_ismelk"
            />
          </label>
        </SwiperSlide>
        <SwiperSlide
          v-if="
            fillter.category != 'villa_house' &&
            fillter.category != 'commercial' &&
            fillter.category != 'garden' &&
            fillter.category != 'land' &&
            fillter.category != 'industrial'
          "
        >
          <label
            class="filterThumb"
            for="les_sad1"
            :class="fillter.les_sad ? 'filter_avtive' : ''"
            @click="set_filter()"
          >
            <div class="filterTit">کمتر از 100 متر</div>
            <input
              type="checkbox"
              hidden
              id="les_sad1"
              v-model="fillter.les_sad"
            />
          </label>
        </SwiperSlide>
        <SwiperSlide
          v-if="
            fillter.category != 'villa_house' &&
            fillter.category != 'commercial' &&
            fillter.category != 'garden' &&
            fillter.category != 'land' &&
            fillter.category != 'industrial'
          "
        >
          <label
            class="filterThumb"
            for="more_sad1"
            :class="fillter.more_sad ? 'filter_avtive' : ''"
            @click="set_filter()"
          >
            <div class="filterTit">بیشتر از 100 متر</div>
            <input
              type="checkbox"
              hidden
              id="more_sad1"
              v-model="fillter.more_sad"
            />
          </label>
        </SwiperSlide>
        <SwiperSlide
          v-if="
            fillter.category != 'commercial' &&
            fillter.category != 'garden' &&
            fillter.category != 'land' &&
            fillter.category != 'industrial'
          "
        >
          <label
            class="filterThumb"
            for="parking1"
            :class="fillter.parking ? 'filter_avtive' : ''"
            @click="set_filter()"
          >
            <div class="filterTit">پارکینگ</div>
            <input
              type="checkbox"
              hidden
              id="parking1"
              v-model="fillter.parking"
            />
          </label>
        </SwiperSlide>
        <SwiperSlide
          v-if="
            fillter.category != 'commercial' &&
            fillter.category != 'garden' &&
            fillter.category != 'land' &&
            fillter.category != 'industrial'
          "
        >
          <label
            class="filterThumb"
            for="storage1"
            :class="fillter.storage ? 'filter_avtive' : ''"
            @click="set_filter()"
          >
            <div class="filterTit">انباری</div>
            <input
              type="checkbox"
              hidden
              id="storage1"
              v-model="fillter.storage"
            />
          </label>
        </SwiperSlide>
        <SwiperSlide v-if="fillter.category == 'commercial'">
          <label
            class="filterThumb"
            for="isglass1"
            :class="fillter.isglass ? 'filter_avtive' : ''"
            @click="set_filter()"
          >
            <div class="filterTit">شیشه سکوریت</div>
            <input
              type="checkbox"
              hidden
              id="isglass1"
              v-model="fillter.isglass"
            />
          </label>
        </SwiperSlide>
        <SwiperSlide v-if="fillter.category == 'commercial'">
          <label
            class="filterThumb"
            for="isremotedoor1"
            :class="fillter.isremotedoor ? 'filter_avtive' : ''"
            @click="set_filter()"
          >
            <div class="filterTit">کرکره برقی</div>
            <input
              type="checkbox"
              hidden
              id="isremotedoor1"
              v-model="fillter.isremotedoor"
            />
          </label>
        </SwiperSlide>

        <SwiperSlide
          v-if="
            fillter.category == 'commercial' || fillter.category == 'garden'
          "
        >
          <label
            class="filterThumb"
            for="iswater1"
            :class="fillter.iswater ? 'filter_avtive' : ''"
            @click="set_filter()"
          >
            <div class="filterTit">آب</div>
            <input
              type="checkbox"
              hidden
              id="iswater1"
              v-model="fillter.iswater"
            />
          </label>
        </SwiperSlide>
        <SwiperSlide
          v-if="
            fillter.category == 'commercial' || fillter.category == 'garden'
          "
        >
          <label
            class="filterThumb"
            for="iselectricity1"
            :class="fillter.iselectricity ? 'filter_avtive' : ''"
            @click="set_filter()"
          >
            <div class="filterTit">برق</div>
            <input
              type="checkbox"
              hidden
              id="iselectricity1"
              v-model="fillter.iselectricity"
            />
          </label>
        </SwiperSlide>
        <SwiperSlide
          v-if="
            fillter.category == 'commercial' || fillter.category == 'garden'
          "
        >
          <label
            class="filterThumb"
            for="isgas1"
            :class="fillter.isgas ? 'filter_avtive' : ''"
            @click="set_filter()"
          >
            <div class="filterTit">گاز</div>
            <input type="checkbox" hidden id="isgas1" v-model="fillter.isgas" />
          </label>
        </SwiperSlide>
        <SwiperSlide v-if="fillter.category == 'commercial'">
          <label
            class="filterThumb"
            for="isceramic1"
            :class="fillter.isceramic ? 'filter_avtive' : ''"
            @click="set_filter()"
          >
            <div class="filterTit">کف سرامیک</div>
            <input
              type="checkbox"
              hidden
              id="isceramic1"
              v-model="fillter.isceramic"
            />
          </label>
        </SwiperSlide>

        <SwiperSlide v-if="fillter.category == 'commercial'">
          <label
            class="filterThumb"
            for="isbalcony1"
            :class="fillter.isbalcony ? 'filter_avtive' : ''"
            @click="set_filter()"
          >
            <div class="filterTit">بالکن</div>
            <input
              type="checkbox"
              hidden
              id="isbalcony1"
              v-model="fillter.isbalcony"
            />
          </label>
        </SwiperSlide>
        <SwiperSlide v-if="fillter.category == 'garden'">
          <label
            class="filterThumb"
            for="inbaft1"
            :class="fillter.inbaft ? 'filter_avtive' : ''"
            @click="set_filter()"
          >
            <div class="filterTit">داخل بافت</div>
            <input
              type="checkbox"
              hidden
              id="inbaft1"
              v-model="fillter.inbaft"
            />
          </label>
        </SwiperSlide>
        <SwiperSlide v-if="fillter.category == 'garden'">
          <label
            class="filterThumb"
            for="outbaft1"
            :class="fillter.outbaft ? 'filter_avtive' : ''"
            @click="set_filter()"
          >
            <div class="filterTit">خارج بافت</div>
            <input
              type="checkbox"
              hidden
              id="outbaft1"
              v-model="fillter.outbaft"
            />
          </label>
        </SwiperSlide>

        <SwiperSlide
          v-if="
            fillter.main_category == 'request' && fillter.request_type == 'buy'
          "
        >
          <label
            class="filterThumb"
            for="rebuild"
            :class="fillter.rebuild ? 'filter_avtive' : ''"
            @click="set_filter()"
          >
            <div class="filterTit">بازسازی شده</div>
            <input
              type="checkbox"
              hidden
              id="isbalcony"
              v-model="fillter.rebuild"
            />
          </label>
        </SwiperSlide>
        <SwiperSlide
          v-if="fillter.category == 'land' || fillter.category == 'garden'"
        >
          <label
            class="filterThumb"
            for="inbaft1"
            :class="fillter.inbaft ? 'filter_avtive' : ''"
            @click="set_filter()"
          >
            <div class="filterTit">داخل بافت</div>
            <input
              type="checkbox"
              hidden
              id="inbaft1"
              v-model="fillter.inbaft"
            />
          </label>
        </SwiperSlide>
        <SwiperSlide
          v-if="fillter.category == 'land' || fillter.category == 'garden'"
        >
          <label
            class="filterThumb"
            for="outbaft1"
            :class="fillter.outbaft ? 'filter_avtive' : ''"
            @click="set_filter()"
          >
            <div class="filterTit">خارج بافت</div>
            <input
              type="checkbox"
              hidden
              id="outbaft1"
              v-model="fillter.outbaft"
            />
          </label>
        </SwiperSlide>
      </Swiper>
    </div>
  </div>
</template>
<!-- <script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import axios from "axios";

const INITIAL_FILTER = (path) => ({
  main_category: "all",
  request_type: "all",
  category: "all",
  text: "",
  location: "",
  min_width: 0,
  max_width: 0,
  min_price: 0,
  max_price: 0,
  min_rent_price: 0,
  max_rent_price: 0,
  min_mortageprice: 0,
  max_mortageprice: 0,
  bed: -1,
  min_age: 0,
  max_age: 0,
  min_floor: "0",
  max_floor: "0",
  min_totalFloor: "0",
  max_totalFloor: "0",
  min_Floorunit: "0",
  max_Floorunit: "0",
  docType: "0",
  parking: false,
  storage: false,
  elevator: false,
  photo: false,
  newProperty: false,
  special: false,
  fast: false,
  request: false,
  advertiser: "",
  district: "0",
  order_by: "newest",
  view_mode: "list",
  user_id: 0,
  city: 0,
  m_id: 0,
  page: 1,
  per_page: path === "/map-house" ? "get" : 12,
  single_unit: false,
  two_room: false,
  three_room: false,
  pent: false,
  exchangeable: false,
  student: false,
  matbakh: false,
  teras: false,
  doblex: false,
  doc_ismelk: false,
  les_sad: false,
  more_sad: false,
  complate_mortage: false,
  rent_mortage: false,
  dayli_rent: false,
  convertable: false,
  iswc: false,
  ispool: false,
  isjacozi: false,
  isglass: false,
  isremotedoor: false,
  iswater: false,
  iselectricity: false,
  isgas: false,
  isceramic: false,
  isbalcony: false,
  outbaft: false,
  inbaft: false,
  pilot: false,
  soblex: false,
  rebuild: false,
  building_license_date: "",
  workEnd: "",
  sub_category: "",
  seatBottom: false,
  liveable: false,
});

const INITIAL_FRONT_SHOW = () => ({
  min_width: 0,
  max_width: 0,
  min_price: 0,
  max_price: 0,
  min_rent_price: 0,
  max_rent_price: 0,
  min_mortageprice: 0,
  max_mortageprice: 0,
  district_list: [],
  sub_category: [],
});

export default {
  name: "filterBox",

  components: { Swiper, SwiperSlide },

  props: {
    selectedCategory: String,
  },

  data() {
    return {
      advertiserOptions: [
        { adverTiserLable: "همه", advertiserValue: "all" },
        { adverTiserLable: "مشاور املاک", advertiserValue: "adviser" },
        { adverTiserLable: "شخصی", advertiserValue: "personal" },
      ],
      propertyAgeOptions: [
        { ageLabel: "انتخاب کنید", ageValue: 0 },
        { ageLabel: "1 سال", ageValue: "1" },
        { ageLabel: "2 سال", ageValue: "2" },
        { ageLabel: "5 سال", ageValue: "5" },
        { ageLabel: "10 سال", ageValue: "10" },
        { ageLabel: "15 سال", ageValue: "15" },
        { ageLabel: "20 سال", ageValue: "20" },
        { ageLabel: "بیش از 20 سال", ageValue: "more" },
      ],
      modules: [],
      showTooltip: false,
      windowWidth: window.innerWidth,
      errors: { width: "", price: "", rent: "", mortage: "" },
      front_show: INITIAL_FRONT_SHOW(),
      fillter: INITIAL_FILTER(this.$route.path),
    };
  },

  computed: {
    // ── مودال از کوئری روت خونده میشه ─────────────────────────
    isFilterOpen() {
      return this.$route.query.filter === "open";
    },

    isMobile() {
      return this.windowWidth < 576;
    },

    isMapRoute() {
      return this.$route.path === "/map-house";
    },

    // ── استایل‌های داینامیک ────────────────────────────────────
    SliderBar() {
      return this.isFilterOpen ? "left: 0" : "left: 100%";
    },

    filterStyles() {
      return this.isFilterOpen
        ? "transform: translateX(0%);"
        : "transform: translateX(100%);";
    },

    dynamicStyles() {
      if (this.isMobile) {
        return this.isFilterOpen
          ? "position:fixed;left:0;right:0;bottom:0;top:auto !important;width:100% !important;height:100% !important;z-index:2003;border-radius:0 !important;transform:translateY(0);transition:all 0.3s ease;"
          : "position:fixed;left:0;right:0;bottom:0;top:auto !important;width:100% !important;height:100% !important;z-index:2003;border-radius:0 !important;transform:translateY(100%);transition:all 0.3s ease;";
      }
      return this.isFilterOpen
        ? "height:492px;overflow:hidden;transition:height 0.3s ease;"
        : "height:0;overflow:hidden;transition:height 0.3s ease;visibility:hidden;";
    },

    mapFilterBox() {
      if (!this.isMapRoute) return "";
      return this.isFilterOpen
        ? "z-index:999;position:absolute;top:0;left:0;right:0"
        : "z-index:900;position:absolute;top:0;left:0;right:0";
    },

    placeholderText() {
      const map = {
        "/map-house": "جستجو در نقشه...",
        "/home": "جستجو در شمال املاک...",
        "/category": "جستجوی آگهی...",
        "/amlak-list": "جستجوی املاک...",
      };
      return map[this.$route.path] ?? "جستجو...";
    },
  },

  watch: {
    selectedCategory(newVal) {
      if (newVal) this.fillter.main_category = newVal;
    },

    "fillter.category"() {
      this.getSubCategory();
    },

    // ── وقتی فیلتر باز/بسته میشه overflow بدی رو مدیریت کن ──
    isFilterOpen(open) {
      document.body.style.overflowY = open ? "hidden" : "auto";

      const mapEl = document.querySelector(".AllShowMapToUSer");
      if (mapEl) {
        if (open) {
          mapEl.style.zIndex = "999999999";
        } else {
          setTimeout(() => {
            mapEl.style.zIndex = "300";
          }, 100);
        }
      }
    },
  },

  methods: {
    openFilter() {
      this.$router.push({
        query: { ...this.$route.query, filter: "open" },
      });
    },

    closeFilter() {
      // const query = { ...this.$route.query };
      // delete query.filter;
      // this.$router.push({ query });
      history.back()
    },

    toggleFilter() {
      this.isFilterOpen ? this.closeFilter() : this.openFilter();
    },

    handleClickOutside(event) {
      const filterBoxEl = this.$refs.filterBox;
      if (
        this.isFilterOpen &&
        filterBoxEl &&
        !filterBoxEl.contains(event.target)
      ) {
        this.closeFilter();
      }
    },

    updateWidth() {
      this.windowWidth = window.innerWidth;
    },

    tooltipHandler() {
      this.showTooltip = !this.showTooltip;
    },

    // ── API ────────────────────────────────────────────────────
    load_district() {
      axios
        .get(`${this.$store.getters.baseUrl}/get-district?id=317`)
        .then((r) => {
          this.front_show.district_list = r.data;
        });
    },

    getSubCategory() {
      this.helperGet(
        `get-post-sub-category?category=${this.fillter.category}`
      ).then((r) => {
        this.front_show.sub_category = r.data.rows;
      });
    },

    // ── فیلتر ─────────────────────────────────────────────────
    async fillter_btn(mode) {
      if (this.isFilterOpen) {
        this.closeFilter();
        await this.$nextTick();
      }

      localStorage.removeItem("post_fillter");
      this.$store.commit("post_fillter_set", [this.fillter, this.front_show]);

      if (this.$route.path === "/home") {
        this.$router.push({
          path: mode === "list" ? "/category" : "/map-house",
        });
      } else {
        this.$emit("reload");
      }
    },

    restore_fillter() {
      this.front_show = INITIAL_FRONT_SHOW();
      this.fillter = INITIAL_FILTER(this.$route.path);
      localStorage.removeItem("post_fillter");
      this.$store.commit("post_fillter_set", [this.fillter, this.front_show]);
      this.$emit("reload");
    },

    // ── فرمت قیمت ─────────────────────────────────────────────
    formatPrice(value) {
      return value
        .toFixed(0)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    setformatPrice(event, param) {
      const raw = event.target.value.replace(/[^\d.-]/g, "");
      this.front_show[param] = this.formatPrice(raw);
      this.fillter[param] = raw;

      this.errors = { width: "", price: "", rent: "", mortage: "" };

      const checks = {
        max_width: {
          cmp: [this.fillter.max_width, this.fillter.min_width],
          key: "width",
          msg: "باید بیشتر از حداقل متراژ باشد.",
        },
        max_price: {
          cmp: [this.fillter.max_price, this.fillter.min_price],
          key: "price",
          msg: "باید بیشتر از حداقل قیمت باشد.",
        },
        max_rent_price: {
          cmp: [this.fillter.max_rent_price, this.fillter.min_rent_price],
          key: "rent",
          msg: "باید بیشتر از حداقل اجاره باشد.",
        },
        max_mortageprice: {
          cmp: [this.fillter.max_mortageprice, this.fillter.min_mortageprice],
          key: "mortage",
          msg: "باید بیشتر از حداقل رهن باشد.",
        },
      };

      const check = checks[param];
      if (check && Number(check.cmp[0]) < Number(check.cmp[1])) {
        this.errors[check.key] = check.msg;
      }
    },
  },

  mounted() {
    this.getSubCategory();

    const route = this.$route.path;
    const skipRestore = ["/category", "/map-house", "/details"];
    if (!skipRestore.includes(route)) {
      this.restore_fillter();
      localStorage.removeItem("post_fillter");
      this.$store.dispatch("checkPostFillter");
    }

    if (this.$route.query.cat) this.fillter.category = this.$route.query.cat;
    if (this.$route.query.main_cat)
      this.fillter.main_category = this.$route.query.main_cat;

    this.load_district();
    this.$store.dispatch("checkPostFillter");

    const stored = this.$store.getters.post_fillter;
    if (stored?.length > 0) {
      this.fillter = stored[0];
      this.front_show = stored[1];
    }

    document.addEventListener("click", this.handleClickOutside);
    window.addEventListener("resize", this.updateWidth);
  },

  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
    window.removeEventListener("resize", this.updateWidth);
  },
};
</script> -->

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import axios from "axios";

export default {
  name: "filterBox",
  props: {
    selectedCategory: String,
  },
  components: { Swiper, SwiperSlide },
  data() {
    return {
      advertiserOptions: [
        {
          adverTiserLable: "همه",
          advertiserValue: "all",
        },
        {
          adverTiserLable: "مشاور املاک",
          advertiserValue: "adviser",
        },
        {
          adverTiserLable: "شخصی",
          advertiserValue: "personal",
        },
      ],
      SliderBar: "left: 100%",
      filterStyles: "transform: translateX(100%);",
      isFilterOpen: false,
      windowWidth: window.innerWidth,
      dynamicStyles:
        window.innerWidth < 576
          ? "position: fixed; left:0; right:0; bottom:0; top:auto !important; width: 100% !important; height:100% !important; z-index:99999; border-radius:0 !important; transform:translateY(100%);  transition: all 0.3s ease;"
          : "height: 0; overflow: hidden; transition: height 0.3s ease;visibility: hidden;",
      filterButton: null,
      filterBox: null,
      errors: {
        width: "",
        price: "",
        rent: "",
        mortage: "",
      },
      propertyAgeOptions: [
        {
          ageLabel: "انتخاب کنید",
          ageValue: 0,
        },

        {
          ageLabel: "1 سال",
          ageValue: "1",
        },
        {
          ageLabel: "2 سال",
          ageValue: "2",
        },
        {
          ageLabel: "5 سال",
          ageValue: "5",
        },
        {
          ageLabel: "10 سال",
          ageValue: "10",
        },
        {
          ageLabel: "15 سال",
          ageValue: "15",
        },
        {
          ageLabel: "20 سال",
          ageValue: "20",
        },
        {
          ageLabel: "بیش از 20 سال",
          ageValue: "more",
        },
      ],
      showTooltip: false,
      isBackAction: false,
      front_show: {
        min_width: 0,
        max_width: 0,
        min_price: 0,
        max_price: 0,
        min_rent_price: 0,
        max_rent_price: 0,
        min_mortageprice: 0,
        max_mortageprice: 0,
        district_list: [],
        sub_category: [],
      },
      fillter: {
        main_category: "all",
        request_type: "all",
        category: "all", //commercial
        text: "",
        location: "",
        min_width: 0,
        max_width: 0,
        min_price: 0,
        max_price: 0,
        min_rent_price: 0,
        max_rent_price: 0,
        min_mortageprice: 0,
        max_mortageprice: 0,
        bed: -1,
        min_age: 0,
        max_age: 0,
        min_floor: "0",
        max_floor: "0",
        min_totalFloor: "0",
        max_totalFloor: "0",
        min_Floorunit: "0",
        max_Floorunit: "0",
        docType: "0",
        parking: false,
        storage: false,
        elevator: false,
        photo: false,
        newProperty: false,
        special: false,
        fast: false,
        request: false,
        advertiser: "",
        district: "0",
        order_by: "newest",
        view_mode: "list",
        user_id: 0,
        city: 0,
        m_id: 0,
        page: 1,
        per_page: this.$route.path == '/map-house' ? 'get' : 12,
        single_unit: false,
        two_room: false,
        three_room: false,
        pent: false,
        exchangeable: false,
        student: false,
        matbakh: false,
        teras: false,
        doblex: false,
        doc_ismelk: false,
        les_sad: false,
        more_sad: false,
        complate_mortage: false,
        rent_mortage: false,
        // rent_mortage: false,
        dayli_rent: false,
        convertable: false,
        iswc: false,
        ispool: false,
        isjacozi: false,
        isglass: false,
        isremotedoor: false,
        iswater: false,
        iselectricity: false,
        isgas: false,
        isceramic: false,
        isbalcony: false,
        outbaft: false,
        inbaft: false,
        pilot: false,
        soblex: false,
        rebuild: false,
        building_license_date: "",
        workEnd: "",
        sub_category: "",
        seatBottom: false,
        liveable: false,
      },
      resolvePopState: null,
    };
  },
  computed: {
    mapFilterBox() {
      return this.$route.path === "/map-house"
        ? "z-index: 900; position: absolute; top: 0; left: 0; right: 0"
        : "";
    },
    placeholderText() {
      if (this.$route.path === "/map-house") return "جستجو در نقشه...";
      else if (this.$route.path === "/home") return "جستجو در شمال املاک...";
      else if (this.$route.path === "/category") return "جستجوی آگهی...";
      else if (this.$route.path === "/amlak-list") return "جستجوی املاک...";
      else return "جستجو...";
    },
  },
  watch: {
    selectedCategory(newVal) {
      if (newVal) {
        this.fillter.main_category = newVal;
      }
    },
    "fillter.category"() {
      this.getSubCategory();
    },
  },
  methods: {
    updateWidth() {
      this.windowWidth = window.innerWidth;
    },
    tooltipHandler() {
      this.showTooltip = !this.showTooltip;
    },
    toggleFilter() {
      if (!this.isFilterOpen) {
        history.pushState(null, "", location.href);
      } else {
        if (!this.isBackAction) {
          history.back();
        }
        document.body.style.overflowY = "auto";
      }
      this.isFilterOpen = !this.isFilterOpen;
      if (this.$route.path === "/map-house") {
        this.mapFilterBox = this.isFilterOpen
          ? "z-index: 999; position: absolute; top: 0; left: 0; right: 0"
          : "z-index: 900; position: absolute; top: 0; left: 0; right: 0";
      }
      this.dynamicStyles = this.isFilterOpen
        ? this.windowWidth < 576
          ? "position: fixed; left:0; right:0; bottom:0; top:auto !important; width: 100% !important; height:100% !important; z-index:2003; border-radius:0 !important; transform:translateY(0);  transition: all 0.3s ease;"
          : "height: 492px; overflow: hidden; transition: height 0.3s ease;"
        : this.windowWidth < 576
        ? "position: fixed; left:0; right:0; bottom:0; top:auto !important; width: 100% !important; height:100% !important; z-index:2003; border-radius:0 !important; transform:translateY(100%);  transition: all 0.3s ease;"
        : "height: 0; overflow: hidden; transition: height 0.3s ease;";
      this.SliderBar = this.isFilterOpen
        ? "left: 0"
        : "left: 0;transition: .2s ease-in-out;background: transparent;";
      if (!this.isFilterOpen) {
        setTimeout(() => {
          this.SliderBar = "left: 100%;";
        }, 200);
      }
      this.filterStyles = this.isFilterOpen
        ? "transform: translateX(0%);"
        : "transform: translateX(100%);";

      if (!this.isFilterOpen && this.windowWidth > 576) {
        this.dynamicStyles = "visibility: hidden;";
      }

      if (this.isFilterOpen) {
        document.body.style = "overflow-y: hidden";
        const element = document.querySelector(".AllShowMapToUSer");
        if (element) {
          element.style.zIndex = "999999999";
        }
      } else if (!this.isFilterOpen) {
        document.body.style = "overflow-y: auto";
        const element = document.querySelector(".AllShowMapToUSer");
        if (element) {
          setTimeout(() => {
            element.style.zIndex = "300";
          }, 100);
        }
      }
    },
    handleClickOutside(event) {
      if (
        this.filterButton &&
        this.isFilterOpen &&
        !this.filterButton.contains(event.target) &&
        (!this.filterBox || !this.filterBox.contains(event.target))
      ) {
        this.toggleFilter();
      }
    },
    load_district() {
      axios
        .get(this.$store.getters.baseUrl + "/get-district?id=317")
        .then((r) => {
          this.front_show.district_list = r.data;
        });
    },
    getSubCategory() {
      this.helperGet(
        `get-post-sub-category?category=${this.fillter.category}`
      ).then((r) => {
        this.front_show.sub_category = r.data.rows;
        console.log("subcategory", r.data.rows);
      });
    },
    set_filter() {
      let self = this;
      setTimeout(() => {
        localStorage.removeItem("post_fillter");
        self.$store.commit("post_fillter_set", [this.fillter, this.front_show]);
        self.$emit("reload");
      }, 1000);
    },
    waitForPopState() {
      return new Promise((resolve) => {
        this.resolvePopState = resolve;
      });
    },
    async fillter_btn(mode) {
      if (this.isFilterOpen) {
        // this.isBackAction = true;
        this.toggleFilter();
        // this.isBackAction = false;
        await this.waitForPopState();
      }
      await this.$nextTick();
      localStorage.removeItem("post_fillter");
      this.$store.commit("post_fillter_set", [this.fillter, this.front_show]);

      if (this.$route.path == "/home") {
        console.log("sd", mode);
        if (mode == "list") {
          this.$router.push({ path: "/category" });
        } else {
          this.$router.push({ path: "/map-house" });
        }
      } else {
        this.$emit("reload");
      }
    },
    restore_fillter() {
      // let route = this.$router.currentRoute._value.path;

      this.front_show = {
        min_width: 0,
        max_width: 0,
        min_price: 0,
        max_price: 0,
        min_rent_price: 0,
        max_rent_price: 0,
        min_mortageprice: 0,
        max_mortageprice: 0,
        district_list: [],
        sub_category: [],
      };

      this.fillter = {
        main_category: "all",
        request_type: "all",
        category: "all", //commercial
        text: "",
        location: "",
        min_width: 0,
        max_width: 0,
        min_price: 0,
        max_price: 0,
        min_rent_price: 0,
        max_rent_price: 0,
        min_mortageprice: 0,
        max_mortageprice: 0,
        bed: -1,
        min_age: 0,
        max_age: 0,
        min_floor: "0",
        max_floor: "0",
        min_totalFloor: "0",
        max_totalFloor: "0",
        min_Floorunit: "0",
        max_Floorunit: "0",
        docType: "0",
        parking: false,
        storage: false,
        elevator: false,
        photo: false,
        newProperty: false,
        special: false,
        fast: false,
        request: false,
        advertiser: "",
        district: "0",
        order_by: "newest",
        view_mode: "list",
        user_id: 0,
        city: 0,
        m_id: 0,
        page: 1,
        per_page: this.$route.path == '/map-house' ? 'get' : 12,
        single_unit: false,
        two_room: false,
        three_room: false,
        pent: false,
        exchangeable: false,
        student: false,
        matbakh: false,
        teras: false,
        doblex: false,
        doc_ismelk: false,
        les_sad: false,
        more_sad: false,
        complate_mortage: false,
        rent_mortage: false,
        // rent_mortage: false,
        dayli_rent: false,
        convertable: false,
        iswc: false,
        ispool: false,
        isjacozi: false,
        isglass: false,
        isremotedoor: false,
        iswater: false,
        iselectricity: false,
        isgas: false,
        isceramic: false,
        isbalcony: false,
        outbaft: false,
        inbaft: false,
        pilot: false,
        soblex: false,
        rebuild: false,
        license: "",
        workEnd: "",
        sub_category: "",
        seatBottom: false,
        liveable: false,
      };
      localStorage.removeItem("post_fillter");
      this.$store.commit("post_fillter_set", [this.fillter, this.front_show]);
      this.$emit("reload");
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(",", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    setformatPrice(event, param) {
      this.front_show[param] = this.formatPrice(
        event.target.value.replace(/[^\d.-]/g, "")
      );
      this.fillter[param] = event.target.value.replace(/[^\d.-]/g, "");

      this.errors.width = "";
      this.errors.price = "";
      this.errors.rent = "";
      this.errors.mortage = "";

      if (param == "max_width") {
        if (this.fillter.max_width < this.fillter.min_width)
          this.errors.width = "باید بیشتر از حداقل متراژ باشد.";
      }

      if (param == "max_price") {
        if (this.fillter.max_price < this.fillter.min_price)
          this.errors.price = "باید بیشتر از حداقل قیمت باشد.";
      }

      if (param == "max_rent_price") {
        if (this.fillter.max_rent_price < this.fillter.min_rent_price)
          this.errors.rent = "باید بیشتر از حداقل اجاره باشد.";
      }

      if (param == "max_mortageprice") {
        if (this.fillter.max_mortageprice < this.fillter.min_mortageprice)
          this.errors.mortage = "باید بیشتر از حداقل رهن باشد.";
      }
    },
  },
  mounted() {
    this.getSubCategory();
    let route = this.$route.path;
    if (route != "/category" && route != "/map-house" && route != "/details") {
      this.restore_fillter();
      localStorage.removeItem("post_fillter");
      this.$store.dispatch("checkPostFillter");
    }

    if (this.$route.query.cat) {
      this.fillter.category = this.$route.query.cat;
    }
    if (this.$route.query.main_cat) {
      this.fillter.main_category = this.$route.query.main_cat;
    }
    this.load_district();
    this.$store.dispatch("checkPostFillter");
    if (this.$store.getters.post_fillter.length > 0) {
      this.fillter = this.$store.getters.post_fillter[0];
      this.front_show = this.$store.getters.post_fillter[1];
    }

    document.addEventListener("click", this.handleClickOutside);
    window.addEventListener("resize", this.updateWidth);

    window.addEventListener("popstate", () => {
      if (this.isFilterOpen) {
        this.isBackAction = true;
        this.toggleFilter();
        this.isBackAction = false;
      }

      if (this.resolvePopState) {
        this.resolvePopState();
        this.resolvePopState = null;
      }
    });
  },
  unmounted() {
    window.removeEventListener("resize", this.updateWidth);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style lang="scss" scoped>
.error-text {
  font-size: 11px;
  padding-right: 27px;
  color: #d42b2b;
}
.filter {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 424px !important;
  height: 100%;
  z-index: 2004;
  border: none !important;
  border-radius: 0 !important;
  transition: 0.2s ease-in-out;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);

  .filterTitle {
    padding: 12px 24px;
    border-bottom: 1px solid rgb(199, 201, 217);

    .filterTitleContainer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      &.firstPageFilterHeader {
        .fromClearButton {
          display: block;
        }
      }

      .fromClearButton {
        display: none;
      }

      h4 {
        font-family: "iranyekanB", sans-serif;
        font-size: 1.25rem;
      }

      .closeFilterBtn {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        background: #0096c7;
        border-radius: 6px;
        color: #fff;
        font-size: 18px;

        .filterBtnBar {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 86%;
          height: 3px;
          background: #fff;
          border-radius: 6px;

          &:first-of-type {
            transform: translate(-50%, -50%) rotate(45deg);
          }

          &:last-of-type {
            transform: translate(-50%, -50%) rotate(-45deg);
          }
        }
      }
    }
  }

  .filter__container {
    width: 90%;
    height: calc(100% - 152px);
    margin: 0 auto;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 24px 0 !important;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }

    .filterTooltip {
      width: 100%;
      padding: 12px;
      border-radius: 0.375rem;
      border: 1px solid #0096c7;
      color: #0096c7;
      font-size: 0.8rem;
      line-height: 1.5rem;
      text-align: justify;
      background: rgb(229, 240, 255);
      display: none;

      &.show {
        display: block;
      }
    }

    .filterSwitchOption {
      margin-top: 16px;
      width: 100%;
      display: grid;
      grid-template-columns: repeat(2, 46%);
      justify-content: space-between;

      .switchOptionBox {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 4px;
        margin-bottom: 20px;

        .switchTitle {
          font-size: 14px;
        }

        .switchBtn {
          width: 68px;
          height: 32px;
          background: #ddd;
          border-radius: 100px;
        }
      }
    }

    .filter__option {
      .filter__option_title {
        .filterPriceTitle {
          .filterPriceInputContainer {
            .fullFilterInput {
              width: 100% !important;

              :deep(.el-select__wrapper) {
                padding: 16px 12px !important;
                border-radius: 12px;
                border: 1px solid rgb(209, 213, 219);
                box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
              }
            }
            .minfullFilterInput {
              width: 90% !important;

              :deep(.el-select__wrapper) {
                padding: 16px 12px !important;
                border-radius: 12px;
                border: 1px solid rgb(209, 213, 219);
                box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
              }
            }

            .roomNumBox {
              display: flex;
              align-items: center;
              justify-content: center;
              min-width: 40px;
              padding: 6px 8px;
              background: #eeeff2;
              border-radius: 6px;
              transition: all 0.15s;
              cursor: pointer;

              &:active {
                transform: scale(0.92);
              }

              &.selected {
                background: #0096c7;
                color: #fff;
                transform: scale(1.07);
              }
            }
          }
        }
      }
    }
  }

  .filterButton__wrapper {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    padding: 16px 0;
    background: #fff;
    display: flex;
    justify-content: center;

    &.wrapperGrid {
      width: 90%;
      margin: 0 auto;
      display: grid;
      grid-template-columns: 48% 48%;
      justify-content: space-between;

      .searchButton {
        width: 100% !important;
      }
    }

    .searchButton {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      width: 90% !important;
      border-radius: 12px !important;

      i {
        font-size: 1.15rem;
      }
    }
  }
}

.filterSearchInput {
  width: 100% !important;
  margin: 0 !important;
  padding: 16px 12px !important;
  font-size: 14px;
  border-radius: 12px;
  border: 1px solid rgb(209, 213, 219);
  box-shadow: 0 1px 2px 0 rgb(0, 0, 0, 0.1);
}

.knobs,
.layer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.button {
  position: relative;
  width: 54px;
  height: 26px;
  overflow: hidden;
}

.button.r,
.button.r .layer {
  border-radius: 100px;
}

.checkbox {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 3;
}

.knobs {
  z-index: 2;
}

.layer {
  width: 100%;
  background-color: #f4f3f3;
  transition: 0.3s ease all;
  z-index: 1;
}
/* Button 3 */
#button-3 .knobs:before {
  content: "";
  position: absolute;
  top: 4px;
  left: 4px;
  width: 18px;
  height: 18px;
  color: #fff;
  font-size: 10px;
  font-weight: bold;
  text-align: center;
  line-height: 1;
  padding: 9px 4px;
  background-color: #b7b7b7;
  border-radius: 50%;
  transition: 0.3s ease all, left 0.3s cubic-bezier(0.18, 0.89, 0.35, 1.15);
}

#button-3 .checkbox:active + .knobs:before {
  width: 46px;
  border-radius: 100px;
}

#button-3 .checkbox:checked:active + .knobs:before {
  margin-left: -26px;
}

#button-3 .checkbox:checked + .knobs:before {
  left: 32px;
  background-color: #0096c7;
}

#button-3 .checkbox:checked ~ .layer {
  background-color: #ebf7fc;
}

.swiperFilterList {
  display: none;
  .swiper {
    .swiper-slide {
      width: auto;
    }
  }

  .filterThumb {
    height: 40px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    border-radius: 8px;
    border: 1px solid #e1e1e1;
    cursor: pointer;

    &.filter_avtive {
      border: 1px solid #0096c7;
      background: #0096c7;
      color: #fff;
    }
  }
}

.headerBttonsWrapper {
  display: flex;
  align-items: center;
  gap: 16px;

  .clearButton {
    display: none;
    align-items: center;
    gap: 6px;
    font-size: 0.8rem;
    height: 32px;
    padding: 0 8px;
    cursor: pointer;
    border: 1px solid #0096c7;
    color: #0096c7;
    border-radius: 6px;

    &.show {
      display: flex;
    }
  }
}

.MapLeftAllShowMapToUSer {
  .topNav__searchbar_wrapper {
    position: absolute;
    top: 28px;
    right: 0;
    left: 0;
    /*right: 24px;*/
    margin: 0 auto !important;
    border-radius: 8px !important;
    height: 42px !important;
    width: 90% !important;
    /*width: 264px !important;*/
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.15) !important;

    .filterbutton_wrapper {
      margin-top: 4px !important;

      svg {
        width: 22px !important;
      }
    }
  }

  .swiperFilterList {
    display: block;
    width: 90%;
    max-width: 546px;
    margin: 0 auto;
    position: absolute;
    top: 78px;
    left: 0;
    right: 0;
  }
}

.titleWrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .showInfo {
    margin-left: 8px;
    cursor: pointer;
  }
}

@media (max-width: 576px) {
  .filter {
    width: 100% !important;
  }

  .filter
    .filter__container
    .filter__option
    .filter__option_title
    .filterPriceTitle
    .filterPriceInputContainer
    .fullFilterInput {
    width: 99% !important;
  }
}
</style>
